/**
 * Optimization rule API wrapper (CRUD + active toggle).
 */
import { api } from '@/utils/api';
import type {
  CreateRuleInput,
  OptimizationRuleDTO,
  UpdateRuleInput,
} from '@shared/types';

/** Filter params accepted by {@link list}. */
export interface RuleListParams {
  adAccountId?: string;
  campaignId?: string;
  isActive?: boolean;
}

/** List the current user's optimization rules, optionally filtered. */
export async function list(params?: RuleListParams): Promise<OptimizationRuleDTO[]> {
  const response = await api.get<OptimizationRuleDTO[]>('/rules', {
    params: {
      ad_account_id: params?.adAccountId,
      campaign_id: params?.campaignId,
      is_active: params?.isActive,
    },
  });
  return response.data;
}

/** Create a new optimization rule. */
export async function create(input: CreateRuleInput): Promise<OptimizationRuleDTO> {
  const response = await api.post<OptimizationRuleDTO>('/rules', input);
  return response.data;
}

/** Update an existing optimization rule. */
export async function update(id: string, input: UpdateRuleInput): Promise<OptimizationRuleDTO> {
  const response = await api.put<OptimizationRuleDTO>(`/rules/${id}`, input);
  return response.data;
}

/** Delete an optimization rule. */
export async function remove(id: string): Promise<void> {
  await api.delete(`/rules/${id}`);
}

/** Enable or disable an optimization rule. */
export async function toggle(id: string, isActive: boolean): Promise<OptimizationRuleDTO> {
  const response = await api.put<OptimizationRuleDTO>(`/rules/${id}/toggle`, { isActive });
  return response.data;
}

export default { list, create, update, remove, toggle };
